import { Paper } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { styled } from "@mui/material/styles";
import * as React from "react";
import { useEffect } from "react";
import { deleteData } from "./Modal/Utility";

export default function DeactivateAlert(props) {
  const {
    type,
    id,
    deleteAlert,
    setDeleteAlert,
    data,
    count,
    handlePage,
    setlistOfIds,
  } = props;

  const [open, setOpen] = React.useState(false);
  const StyledPaper = styled(Paper)`
    background-color: #1a2c2b;
    color: rgb(249, 215, 161);
  `;

  useEffect(() => {
    setOpen(deleteAlert);
  }, [deleteAlert]);

  const handleClose = () => {
    setOpen(false);
    setDeleteAlert(false);
  };

  const handleDelete = () => {
    setlistOfIds([]);
    deleteData(type, id);
    setOpen(false);
    setDeleteAlert(false);
    if (data && data.length == 1) {
      handlePage(count - 2);
    }
  };

  return (
    <span>
      <Dialog
        open={open}
        keepMounted
        onClose={handleClose}
        aria-describedby="delte-alert"
        fullWidth
        PaperComponent={StyledPaper}
      >
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            style={{ color: "rgb(249, 215, 161)" }}
          >
            <div>
              <div>Are you sure, you want to deactivate the study ?</div>
              <div style={{ color: "white", paddingTop: "1rem" }}>
                Note:- Deactivating the study will stop the further proccessing
                of the study.
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} style={{ color: "#198754ff" }}>
            No
          </Button>
          <Button onClick={handleDelete} style={{ color: "#198754ff" }}>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </span>
  );
}
